export default __webpack_public_path__ + "static/media/saturn.59d4a8b8.jpg";